interface IceServer {
  urls: string;
  username?: string;
  credential?: string;
}

interface EnvironmentConfig {
  brickter: {
    name: string;
  };
  production: boolean;
  debug: boolean;
  cheeky: {
    host: string;
  };
  usage: {
    app_id: number;
    app_name: string;
  };
  dish: {
    host: string;
    iceServers: IceServer[];
  };
  api: {
    host: string;
  };
}

class EnvironmentConfigBuilder {
  private isMinDef: boolean;
  private dev: boolean;
  private preprod: boolean;
  private domain: string;
  private apiDomain: string;

  constructor() {
    this.isMinDef = process.env.REACT_APP_CLIENT === 'mindef';

    if (this.isMinDef) {
      this.preprod = process.env.REACT_APP_ENV === 'preproduction';

      // NOTE: Throw this for now in mindef
      if (this.preprod) {
        throw new Error('Preproduction environment is not supported');
      }

      this.dev = false;
      this.domain = this.preprod ? 'https://192.168.169.3' : 'https://192.168.169.3';
      this.apiDomain = this.preprod ? 'https://192.168.169.3' : 'https://192.168.169.3';
    } else {
      this.dev = (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development');
      this.preprod = process.env.REACT_APP_ENV === 'preproduction';
      this.domain = this.dev ? 'https://sippar4.enovait.biz' : this.preprod ? 'https://internalsippar.com' : 'https://telemedicinacomitas.com';
      this.apiDomain = this.dev ? 'https://sippar4.enovait.biz' : this.preprod ? 'https://internalsippar.com' : 'https://telemedicinacomitas.com';
    }
  }

  getIceServers(): IceServer[] {
    if (this.isMinDef) {
      return [
        {
          urls: this.preprod ? "stun:192.168.169.3:3478" : "stun:62.14.44.107:3478"
        },
        {
          urls: this.preprod ? "turn:192.168.169.3:3478?transport=udp" : "turn:62.14.44.107:3478?transport=udp",
          username: process.env.TURN_USERNAME || 'mindef',
          credential: process.env.TURN_CREDENTIAL || 'changeme'
        },
      ];
    } else {
      return [
        {
          urls: (this.dev || this.preprod) ? "stun:telemedicinacomitas.com:3478" : "stun:telemedicinacomitas.com:3478"
        },
        {
          urls: (this.dev || this.preprod) ? "turn:telemedicinacomitas.com:3478?transport=udp" : "turn:telemedicinacomitas.com:3478?transport=udp",
          username: 'enovait',
          credential: 'password'
        },
      ];
    }
  }

  /**
   * Check if the current configuration is for MinDef client
   */
  isMinDefClient(): boolean {
    return this.isMinDef;
  }

  /**
   * Check if auto-update should be available
   * Auto-update is only available for non-MinDef clients
   */
  isAutoUpdateAvailable(): boolean {
    return !this.isMinDef;
  }

  /**
   * Check if MinDef logos should be shown
   */
  shouldShowMinDefLogos(): boolean {
    return this.isMinDef;
  }

  build(): EnvironmentConfig {
    return {
      brickter: {
        name: 'comitas',
      },
      production: this.isMinDef ? !this.preprod : !this.dev && !this.preprod,
      debug: this.isMinDef ? this.preprod : this.dev,
      cheeky: {
        host: this.domain,
      },
      usage: {
        app_id: this.isMinDef ? 2 : 1,
        app_name: this.isMinDef ? 'mindef-sippar4-frontend' : 'sippar4-frontend',
      },
      dish: {
        host: this.domain,
        iceServers: this.getIceServers(),
      },
      api: {
        host: this.apiDomain,
      },
    };
  }
}

// Crear instancia singleton
const configBuilder = new EnvironmentConfigBuilder();

// Exportar la configuración
export const environment = configBuilder.build();

// Exportar el builder para acceder a métodos específicos como getIceServers()
export const environmentConfig = configBuilder;

// Exponer ICE servers en el objeto window para uso en archivos JS legacy
if (typeof window !== 'undefined') {
  (window as any).__ICE_SERVERS__ = configBuilder.getIceServers();
}
